<script setup lang="ts">
import { computed, watch } from 'vue';
import { RouterView } from 'vue-router';
import useA365Themes from '@/composables/a365themes';

import AfsToasts from '@a365/ui/components/Toasts';

const a365Themes = useA365Themes();

const a365ThemeClass = computed(() => {
  switch (a365Themes.currentTheme.value) {
    case 'dark':
    case 'dark-contrast':
      return 'is-dark-theme';
    case 'light':
    default:
      return 'is-light-theme';
  }
});

watch(
  () => a365ThemeClass.value,
  (newValue, oldValue) => {
    document.body.classList.add(newValue);

    if (oldValue)
      document.body.classList.remove(oldValue);
  },
  { immediate: true }
)
</script>

<template>
  <RouterView />
  <AfsToasts :z-index="1100" />
</template>
